import { createFetcher } from '../../Fetcher/Fetcher'
import {
  getBaseUrl,
  RESULT_ENDPOINT,
  QUIZ_ENDPOINT,
  ADMIN_ENDPOINT,
} from '../../constant'
import { unixTimeStamp } from '../../utils'

const safeUnixTimeStamp = (value) => {
  if (value == null) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  try {
    return unixTimeStamp(value)
  } catch {
    return null
  }
}

export class Result {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Result(
        RESULT_ENDPOINT,
        QUIZ_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher()
      )
    }
    return this.instance
  }

  constructor(endpoint, quizendPoint, adminEndPoint, fetcherObj) {
    this.endpoint = endpoint
    this.quizendPoint = quizendPoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
  }

  static get baseUrl() {
    return getBaseUrl()
  }

  async getResults(quizId, resultPageLimit, resultsPageOffset) {
    const url = `${
      Result.baseUrl + this.adminEndPoint
    }/quiz/${quizId}/responses?limit=${resultPageLimit}&offset=${resultsPageOffset}`
    const response = await this.fetcher.getData(url)

    const list = response?.data?.data

    if (Array.isArray(list)) {
      response.data.data = [...list].sort(
        (a, b) => (b?.evaluatedMarks ?? 0) - (a?.evaluatedMarks ?? 0)
      )
    }

    return response
  }

  async getAllResults(quizId) {
    const url = `${
      Result.baseUrl + this.adminEndPoint
    }/quiz/${quizId}/responses`
    const response = await this.fetcher.getData(url)

    const list = response?.data?.data

    if (Array.isArray(list)) {
      response.data.data = [...list].sort(
        (a, b) => (b?.evaluatedMarks ?? 0) - (a?.evaluatedMarks ?? 0)
      )
    }

    return response
  }

  async getResultSheet(candidateId, quizId) {
    const url = `${Result.baseUrl + this.adminEndPoint}/quiz/${quizId}${
      this.endpoint
    }/${candidateId}`
    const response = await this.fetcher.getData(url)

    if (
      response?.data?.data &&
      Object.prototype.hasOwnProperty.call(response.data.data, 'submissionTime')
    ) {
      response.data.data.submissionTime = safeUnixTimeStamp(
        response.data.data.submissionTime
      )
    }

    return response
  }

  async geIndividualResult(quizId, reqDataArg) {
    const url = `${Result.baseUrl + this.adminEndPoint}/quiz/${quizId}${
      this.endpoint
    }/${reqDataArg}`
    const response = await this.fetcher.getData(url)

    if (
      response?.data?.data &&
      Object.prototype.hasOwnProperty.call(response.data.data, 'submissionTime')
    ) {
      response.data.data.submissionTime = safeUnixTimeStamp(
        response.data.data.submissionTime
      )
    }

    return response
  }
}

export const createResult = () => Result.getInstance()
